import { DataType } from '../../DataType';
import { validateArguments } from '../../SignatureValidation';
export var IsNullFn;
(function (IsNullFn) {
    IsNullFn.Name = `ISNULL`;
    IsNullFn.Stage = "SCALAR";
    IsNullFn.Signature = `ISNULL(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: IsNullFn.Name,
            stage: IsNullFn.Stage,
            data: { type: DataType.BooleanType.make(), role },
            value(value) {
                if (arguments.length === 1) {
                    return value === null;
                }
                throw new Error(`ISNULL function expects 1 arguments ` +
                    `but received ${arguments.length}`);
            },
        };
    }
    IsNullFn.make = make;
    function validate(callNode, callName, args) {
        return validateArguments({
            meta: {
                name: IsNullFn.Name,
                signature: IsNullFn.Signature,
                location: callNode.location,
            },
            arguments: [
                {
                    stages: [
                        "ANALYTIC",
                        "AGGREGATE",
                        "SCALAR",
                        "CONST",
                    ],
                },
            ],
        }, args);
    }
    IsNullFn.validate = validate;
})(IsNullFn || (IsNullFn = {}));
